import React, { useState, useEffect } from "react";
import { Container, Col, FormGroup, Label, Input } from "reactstrap";
import { Formik, Form } from "formik";
import { Loading } from "../../share/loading";
import { useNavigate, useSearchParams } from "react-router-dom";

import * as Yup from "yup";
import "../../share/form.css";
import Swal from "sweetalert2";
import { format } from "date-fns";
import { FaSistrix } from "react-icons/fa";

export function SupportDetailAdminCheckTransferComponent() {
  useEffect(() => {
    // getdatafromview();
  }, []);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const user = JSON.parse(localStorage.getItem("userData"));

  const [loading, setLoading] = useState(false);

  // async function getdatafromview() {
  //   setLoading(true);
  //   try {
  //     let res = await fetch("/api/Support/getV41TopicSupport");
  //     const data = await res.json();
  //     setData(data.dataenum);
  //     console.log("data", data);
  //   } catch (e) {
  //     console.log("err =>" + e);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center">
      

      {user.roldId === "1" ? (
        <Container className="d-flex flex-column justify-content-center align-items-center">
        <p
          className="text-center py-2 text-white"
          style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "850px" }}
        >
          ข้อมูลการจัดสรรเงินช่วยเหลือหรืออุดหนุน
        </p>
        <div className="form-border">
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>เลขที่คำขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>ชื่อผู้ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>จำนวนเงินที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>จำนวนเงินที่โอน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่โอนเงิน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="w-100 d-flex align-items-center justify-content-center">
            <button
              className="btn-blue rounded-pill w-50 my-5"
              onClick={() => {
                navigate(
                  `/supporting/admin/check/detail?id=${searchParams.get("req")}`
                );
              }}
            >
              ดูรายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุนเพิ่มเติม
              <FaSistrix className="mx-2 style-icon" />
            </button>
          </div>
        </div>
        
        <div className="w-100 d-flex align-items-center justify-content-center mt-3 ">
          <button className="btn-blue p-2 w-25">รอจ่ายเงิน</button>
        </div>
        </Container>
      ) : (
        null
      )}

      {user.roldId === "2" ? (
        <Container className="d-flex flex-column justify-content-center align-items-center">
        <p
          className="text-center py-2 text-white"
          style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "850px" }}
        >
          ข้อมูลการจัดสรรเงินช่วยเหลือหรืออุดหนุน
        </p>
        <div className="form-border">
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>เลขที่คำขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>ชื่อผู้ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>จำนวนเงินที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>จำนวนเงินที่โอน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่โอนเงิน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="w-100 d-flex align-items-center justify-content-center">
            <button
              className="btn-blue rounded-pill w-50 my-5"
              onClick={() => {
                navigate(
                  `/supporting/admin/check/detail?id=${searchParams.get("req")}`
                );
              }}
            >
              ดูรายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุนเพิ่มเติม
              <FaSistrix className="mx-2 style-icon" />
            </button>
          </div>
        </div>

        <div className="w-100 d-flex align-items-center justify-content-center mt-3 ">
          <button className="btn-blue p-2 w-25">รอจ่ายเงิน</button>
        </div>
        </Container>
      ) : (
        null
      )}
      {user.roldId === "3" ? (
        <Container className="d-flex flex-column justify-content-center align-items-center">
        <p
          className="text-center py-2 text-white"
          style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "850px" }}
        >
          ข้อมูลการจัดสรรเงินช่วยเหลือหรืออุดหนุน
        </p>
        <div className="form-border">
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>เลขที่คำขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>ชื่อผู้ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>จำนวนเงินที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>จำนวนเงินที่โอน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่โอนเงิน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="w-100 d-flex align-items-center justify-content-center">
            <button
              className="btn-blue rounded-pill w-50 my-5"
              onClick={() => {
                navigate(
                  `/supporting/admin/check/detail?id=${searchParams.get("req")}`
                );
              }}
            >
              ดูรายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุนเพิ่มเติม
              <FaSistrix className="mx-2 style-icon" />
            </button>
          </div>
        </div>
        <div className="w-100 d-flex align-items-center justify-content-center mt-3 ">
          <button className="btn-blue p-2 w-25">รับจัดสรร</button>
        </div>
        </Container>
      ) : (
        null
      )}

      {user.roldId === "4" ? (
        <Container className="d-flex flex-column justify-content-center align-items-center">
        <p
          className="text-center py-2 text-white"
          style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "850px" }}
        >
          ข้อมูลการจัดสรรเงินช่วยเหลือหรืออุดหนุน
        </p>
        <div className="form-border">
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>เลขที่คำขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>ชื่อผู้ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>จำนวนเงินที่ขอ</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="px-5 mt-5 d-flex w-100 d-flex align-items-center justify-content-evenly">
            <div className="d-flex flex-row align-items-center justify-content-around w-50">
              <Label>จำนวนเงินที่โอน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
            <div className="d-flex align-items-center justify-content-around w-50 ms-2">
              <Label>วันที่โอนเงิน</Label>
              <p className="rounded-pill p-3 border w-50"></p>
            </div>
          </div>
  
          <div className="w-100 d-flex align-items-center justify-content-center">
            <button
              className="btn-blue rounded-pill w-50 my-5"
              onClick={() => {
                navigate(
                  `/supporting/admin/check/detail?id=${searchParams.get("req")}`
                );
              }}
            >
              ดูรายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุนเพิ่มเติม
              <FaSistrix className="mx-2 style-icon" />
            </button>
          </div>
        </div>
        <div className="w-100 d-flex align-items-center justify-content-center mt-3 ">
          <button className="btn-blue p-2 w-25">โอนเงินแล้ว</button>
        </div>
        </Container>
      ) : (
        null
      )}

    </Container>
  );
}
